import { render, staticRenderFns } from "./VocStatus.vue?vue&type=template&id=8ca16f72&scoped=true&"
import script from "./VocStatus.vue?vue&type=script&lang=js&"
export * from "./VocStatus.vue?vue&type=script&lang=js&"
import style0 from "./VocStatus.vue?vue&type=style&index=0&id=8ca16f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca16f72",
  null
  
)

export default component.exports